import React, { useState, useEffect, useRef }  from 'react'
import '../CoursePage/CoursePage.css'
import Curriculum from "../Curriculum/Curriculum.jsx";
import jrleftgirl from "../../assets/jrleftgirl.png";
import jrrightgirl from "../../assets/jrrightgirl.png";
import foundational from "../../assets/fshfoundational.jpg";
import intermediate from "../../assets/dahintermediate.png";
import advanced from "../../assets/dah1intermediate.png";
import coursepath1 from '../../assets/coursepath1.jpg';
import coursepath2 from '../../assets/coursepath2.jpg';
import coursepath3 from '../../assets/coursepath3.jpeg';
import coursepath4 from '../../assets/coursepath4.jpg';
import coursepathl1 from '../../assets/coursepathl1.png';
import coursepathl2 from '../../assets/coursepathl2.png';
import coursepathl3 from '../../assets/coursepathl3.png';

import cloudzest from '../../assets/cloudzest.jpg'
import virtusa from '../../assets/Virtusa.png'
import cognizant from '../../assets/cognizant.png'
import lancesoft from '../../assets/Lancesoft.png'
import accenture from '../../assets/Accenture.png'
import techmahindra from '../../assets/TMlogo.png'
import trigent from '../../assets/trigent.png'
import info from '../../assets/info.jpg'
import lti from '../../assets/lti.png'
import prodapt from '../../assets/prodapt.png'
import straive from '../../assets/straive.jpg'
import concentrix from '../../assets/Concentrix.png'
import nttdata from '../../assets/ntt data.png'
import walkingtree from '../../assets/walkingtree.png'
import globallogic from '../../assets/globallogic.png'
import blueyonder from '../../assets/blueyonder.png'
import deloitte from '../../assets/deloitte.png'
import covalense from '../../assets/covalense.jpg'
import statusneo from '../../assets/statusneo.jpg'
import capgemini from "../../assets/logos/Capgemini Logo.webp";

import hirecompanylogo from "../../assets/hirecompanylogo1.png";
import mentorcompany from '../../assets/mentorcompany.png';
import trusted from "../../assets/WebsitePlacement.png";
import mentorimage from '../../assets/mentorimage.png';
import mentorimage2 from '../../assets/mentorimage2.png';
import mentorimage3 from '../../assets/mentorimage3.png';
import mentorimage4 from '../../assets/mentorimage4.png';
import mentorimage5 from '../../assets/mentorimage5.png';
import mentorimage6 from '../../assets/mentorimage6.png';
import mentorimage8 from '../../assets/mentorimage8.png';
import mentorimage9 from '../../assets/mentorimage9.png';
import mentorimage10 from '../../assets/mentorimage10.jpeg';
import mentorimage11 from '../../assets/mentorimage11.png';
import mentorimage12 from '../../assets/mentorimage12.png';
import mentorimage13 from '../../assets/mentorimage13.png';
import mentorimage14 from '../../assets/mentorimage14.png';
import mentorimage15 from '../../assets/mentorimage15.JPG';
import mentorimage16 from '../../assets/mentorimage16.png';
import mentorimage17 from '../../assets/mentorimage17.png';
// import mentorimage18 from '../../assets/mentorimage18.jpeg';
import mentorimage19 from '../../assets/mentorimage19.png';
import mentorimage20 from '../../assets/mentorimage20.png';
import mentorimage21 from '../../assets/mentorimage21.png';
import mentorimage22 from '../../assets/mentorimage22.png';
import mentorimage23 from '../../assets/mentorimage23.png';
import mentorimage24 from '../../assets/mentorimage24.png';
import mentorimage25 from '../../assets/mentorimage25.png';
import mentorimage26 from '../../assets/mentorimage26.png';
import mentorimage27 from '../../assets/mentorimage27.png';
import mentorimage28 from '../../assets/mentorimage28.png';
import certificate from '../../assets/certificatecourse.png';
import ibmcertificate from '../../assets/certificateportion2.png';
import microsoftcertificate from '../../assets/certificateportion1.png';
import bessential from "../../assets/bootcampessential.png";
import bplus from "../../assets/bootcampplus.png";
import bpro from "../../assets/bootcamppro.png";
import boexcel from '../../assets/boexcel.jpg';
import bosql from '../../assets/bosql.png';
import bopowerbi from'../../assets/bopowerbi.jpg';
import botableau from '../../assets/botableau.jpg';
import bonumpypanda from '../../assets/bonumpypanda.png';
import bobusinessstatistics from '../../assets/bobusinessstatistics.jpg';
import bopython from '../../assets/bopython.jpg';
import boaws from '../../assets/boaws.png';
import bobigdata from '../../assets/bobigdata.png';
import { FaUsersLine } from "react-icons/fa6";
import { LuSendHorizontal } from "react-icons/lu";

const CoursePage = () => {

      const [activeTab, setActiveTab] = useState('IBM');

  const statsData = [
    { number: 120, text: "Live Hours" },
    { number: 40, text: "Tools" },
    { number: 20, text: "Projects" },
    { number: 50, text: "Assessments" },
    { number: 250, text: "Mentorship Hours" },
  ];

  const [counts, setCounts] = useState(statsData.map(() => 0));

  useEffect(() => {
    const intervals = statsData.map((stat, index) => {
      return setInterval(() => {
        setCounts((prevCounts) => {
          const newCounts = [...prevCounts];
          if (newCounts[index] < stat.number) {
            newCounts[index] += 1; // Increase by 1 per interval
          } else {
            clearInterval(intervals[index]); // Stop when target reached
          }
          return newCounts;
        });
      }, 80); // Adjust speed for smoother animation
    });

    return () => intervals.forEach(clearInterval); // Cleanup on unmount
  }, []);


  const curriculumRef = useRef(null); // Create a reference

  // Function to scroll to the Curriculum component
  const handleScrollToCurriculum = () => {
    if (curriculumRef.current) {
      curriculumRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const Card = ({ image, title, description }) => (
    <div className="Handonexperience-card">
      <img src={image} alt={title} className="Handonexperience-card-image" />
      <h2 className="Handonexperience-card-title">{title}</h2>
      <p className="Handonexperience-card-description">{description}</p>
    </div>
  );

  const companyLogos = [
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo,
    hirecompanylogo
  ];

  const mentors = [
    { name: "Venkata Sai", role: "React.Js Developer", image: mentorimage, company: cloudzest },
    { name: "Bhargav Lakshman", role: "React.Js Developer", image: mentorimage2, company: capgemini },
    { name: "Burra Jyothi", role: "React.Js Developer", image: mentorimage3, company: virtusa },
    { name: "Chinna Ram", role: "React.Js Developer", image: mentorimage4, company: cognizant },
    { name: "Nagi Reddy", role: "React.Js Developer", image: mentorimage5, company: lancesoft },
    { name: "Guguloth Veranna", role: "React.Js Developer", image: mentorimage6, company: accenture },
    { name: "Jangam Rajasekhar", role: "React.Js Developer", image: mentorimage8, company: techmahindra},
    { name: "Leelachaitanya", role: "React.Js Developer", image: mentorimage9, company: trigent },
    { name: "Satyavamsi", role: "React.Js Developer", image: mentorimage10, company: info },
    { name: "Naresh Kumar", role: "React.Js Developer", image: mentorimage11, company: lti },
    { name: "Gopinadh Reddy", role: "React.Js Developer", image: mentorimage12, company: prodapt},
    { name: "Mahesh Bathula", role: "React.Js Developer", image: mentorimage13, company: accenture},
    { name: "Mahesh Nandibattina", role: "React.Js Developer", image: mentorimage14, company: straive },
    { name: "Krishna Reddy", role: "React.Js Developer", image: mentorimage15, company: lti },
    { name: "Pavan Kalyan", role: "React.Js Developer", image: mentorimage16, company: lti },
    { name: "Nitta Vinod", role: "React.Js Developer", image: mentorimage17, company: concentrix },

    { name: "Thirupathamma", role: "React.Js Developer", image: mentorimage19, company: nttdata },
    { name: "Simhachalam", role: "React.Js Developer", image: mentorimage20, company: walkingtree },
    { name: "Srevali Pachi pulusu", role: "Reactjs Developer", image: mentorimage21, company: globallogic },
    { name: "Vasam Arunkumar", role: "React.Js Developer", image: mentorimage22, company: blueyonder },
    { name: "Raja Sekhar", role: "React.Js Developer", image: mentorimage23, company: techmahindra },
    { name: "vijay bhele", role: "React.Js Developer", image: mentorimage24, company: accenture },
    { name: "Mekala Anil", role: "React.Js Developer", image: mentorimage25, company: deloitte },
    { name: "Pooja Joshi", role: "React.Js Developer", image: mentorimage26, company: concentrix },
    { name: "Naveen kumar", role: "React.Js Developer", image: mentorimage27, company: covalense},
    { name: "Akhil", role: "React.Js Developer", image: mentorimage28, company: statusneo },
  ];

  const carouselRef = useRef(null);

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        if (carouselRef.current.scrollLeft >= carouselRef.current.scrollWidth / 2) {
          // Reset scroll to create infinite loop effect
          carouselRef.current.scrollLeft = 0;
        } else {
          carouselRef.current.scrollLeft += 1; // Adjust for smooth speed
        }
      }
    }, 30); // Adjust speed here

    return () => clearInterval(scrollInterval);
  }, []);

  const Cards = ({ image, title, description }) => (
    <div className="bootcamp-card">
      <img src={image} alt={title} className="bootcamp-card-image" />
      <h2 className="bootcamp-card-title">{title}</h2>
      <p className="bootcamp-card-description">{description}</p>
    </div>
  );

  const [activeTabs, setActiveTabs] = useState(0);
  
    const tabs = [
      "Entry Criteria",
      "Program Delivery + Expected Outcomes",
      "Payment Details",
      "Interview Opportunity",
    ];
  
    const faqs = [
      {
        question: "Can I get any special discount for this program?",
        answer:
          "We are offering you this program at competitive rates. Hence, we are not offering any discounts; however, we have a lot of financing options to support you to do this program.",
      },
      {
        question: "What financing options do I have?",
        answer: "",
      },
      {
        question: "What are the documents required for opting for an EMI?",
        answer: "",
      },
      {
        question:
          "If a student doesn’t get placed, will he/she be eligible for a Program fee refund?",
        answer: "",
      },
    ];
  
    const toggleTab = (index) => {
      setActiveTabs(index);
    };
  
  
    const [currentTab, setCurrentTab] = useState("Full Stack Developer");
  
    // Data for info cards for each tab
    const tabData = {
      "Full Stack Developer": [
        {
          title: "Annual Average Salaries",
          image: "bragraph", // Replace with your actual variable
          companies: [],
          description: "",
        },
        {
          title: "Top Companies",
          companies: [
            "amazonlogo", // Replace with your actual variable names
            "axislogo",
            "accenturelogo",
            "careerlogo",
            "capgeminilogo",
          ],
        },
        {
          title: "Demand",
          image: "demandpie", // Replace with your actual variable
          description: "Surge in job postings between 2020 and 2023",
        },
      ],
      "Team Lead": [
        {
          title: "Leadership Salaries",
          image: "leadershipGraph", // Replace with your actual variable
        },
        {
          title: "Growing Companies",
          companies: [
            "teamLeadLogo1",
            "teamLeadLogo2",
            "teamLeadLogo3",
          ],
        },
        {
          title: "Demand",
          image: "teamDemandGraph", // Replace with your actual variable
          description: "Growth in demand for leadership roles",
        },
      ],
      "Director of Engineering": [
        {
          title: "Director Salaries",
          image: "directorGraph", // Replace with your actual variable
        },
        {
          title: "High-Level Companies",
          companies: [
            "directorLogo1",
            "directorLogo2",
            "directorLogo3",
          ],
        },
        {
          title: "Demand",
          image: "directorDemandGraph", // Replace with your actual variable
          description: "Demand for engineering leadership roles",
        },
      ],
    };

    const certifications = {
      IBM: {
        title: 'Course Completion Certificate from IBM',
        points: [
          'Complete your training with the internationally recognized certificate.',
          'Validate your Data Science skills with IBM Course Completion Certificate.',
          'Get acknowledged in IT sector by adding IBM Certificate to your profile.'
        ],
        img: ibmcertificate
      },
      Microsoft: {
        title: 'Course Completion Certificate from Microsoft',
        points: [
          'Complete your training with Microsoft Certification.',
          'Validate your skills with Microsoft Course Completion Certificate.',
          'Showcase your expertise with globally recognized certificates.'
        ],
        img: microsoftcertificate
      },
      'Project Certificate': {
        title: 'Project Completion Certificate',
        points: [
          'Successfully complete your capstone projects.',
          'Work with industry-standard tools and technologies.',
          'Showcase your hands-on project experience.'
        ],
        img: certificate
      }
    };
  

  return (

    <div>
    <div>
      <div className="hero-wrapper">
        <div className="container-course-page">
          <div className="tagline">Design & Shape the Future of Coding with AI Code Assistant!</div>
          <h1 className="title">Advanced Job-Ready Full Stack Web Development with AI Integration</h1>
          <p className="subtitle">
            Transform your Tech Career with Industry-Aligned, In-Demand Skills and AI-Powered Code Assistance
          </p>
          <div className="button-wrapper">
            <button className="apply-button">Apply Now</button>
            <button className="download-button" onClick={handleScrollToCurriculum}>Download Syllabus</button>
          </div>
          <div className="content-wrapper">

            <img src={jrleftgirl} alt="Person 1" className="image-wrapper" />

            <div className="text-wrapper">
              <div className="feature">
                {/* <LuSendHorizontal className="course-1-icons" /> */}
                <p className="feature-text">
                  <b>Master In-Demand Skills:</b> Gain expertise in advanced technologies in Mongo DB, Express JS, React JS, Node JS, AWS/Azure Cloud, Figma, Generative AI Skills.
                </p>
              </div>
              <div className="feature">
                {/* <LuSendHorizontal className="course-1-icons" /> */}
                <p className="feature-text">
                  <b>Learn from Industry Experts:</b> Receive mentorship from expert professionals & personalized guidance.
                </p>
              </div>
              <div className="feature">
                {/* <LuSendHorizontal className="course-1-icons" /> */}
                <p className="feature-text">
                  <b>Land Your Dream Job:</b> Secure opportunities at top-tier tech companies and innovative startups.
                </p>
              </div>
            </div>


            <img src={jrrightgirl} alt="Person 2" className="image-wrapper" />

          </div>
        </div>

      </div>

      <div className="stats">
      {statsData.map((stat, index) => (
        <div className="stat" key={index}>
          <h2 className="stat-number">{counts[index]}+</h2>
          <p className="stat-text">{stat.text}</p>
        </div>
      ))}
    </div>

     <div ref={curriculumRef}>
      <Curriculum />
      </div>

      <>
        <div className="Handonexperience-container">
          <header className="Handonexperience-header">
            <h3 className="Handonexperience-subheading">
              Build you skills through real world projects
            </h3>
            <h1 className="Handonexperience-heading">
              Gain Hands-on Experience that Sets You Apart
            </h1>
          </header>

          <section className="Handonexperience-offerings">
            <Card
              image={foundational}
              title="Foundational Project: Web Development (Weeks 1-10)"
              description="Build a solid DSA foundation by designing and implementing Java projects like a banking system."
            />
            <Card
              image={intermediate}
              title="Intermediate Project: Database Integration (Week 11-20)"
              description="Build a strong foundation by creating websites with HTML, CSS, React and JavaScript."
            />
            <Card
              image={advanced}
              title="Advanced Project: Full-Stack Implementation (Week 21-30)"
              description="Master web-development using Express, MongoDB and REST APIs for dynamic applications."
            />
          </section>
          <section className="Handonexperience-offerings">
            <Card
              image={foundational}
              title="Foundational Project: Web Development (Weeks 1-10)"
              description="Build a solid DSA foundation by designing and implementing Java projects like a banking system."
            />
            <Card
              image={intermediate}
              title="Intermediate Project: Database Integration (Week 11-20)"
              description="Build a strong foundation by creating websites with HTML, CSS, React and JavaScript."
            />
            <Card
              image={advanced}
              title="Advanced Project: Full-Stack Implementation (Week 21-30)"
              description="Master web-development using Express, MongoDB and REST APIs for dynamic applications."
            />
          </section>
        </div>
      </>

      <div className='course-path-container'>
        <p className='course-path-title'>Facts of AI Enhance Full Stack Development Job Opportunities</p>
        <p className='course-path-mini-title'>FULLSTACK DEVELOPMENT WITH AI JOB ROLES</p>

        <div className='course-path-sub-cont'>

          <div className='course-path-sub-imgs'>

            <img src={coursepathl1} alt="" className='course-path-right-image-1'/>
            <img src={coursepathl2} alt="" className='course-path-right-image-2'/>
            <img src={coursepathl3} alt="" className='course-path-right-image-2'/>

          </div>

          <div className='course-path-sub-data'>

            <div className='course-path-1'>
              <img src={coursepath1} alt="" className='course-path-1-img'/>
              <div className='course-path-1-data'>
                <p1>AI-Backend
                Developer</p1>
                <p2>A Front-End Developer is responsible for developing new user-facing features, determining the structure and design of web pages, building reusable codes, optimizing page loading times, and using a variety of markup languages to create the web pages.</p2>
              </div>
            </div>
            <div className='course-path-1'>
              <img src={coursepath2} alt="" className='course-path-1-img'/>
              <div className='course-path-1-data'>
                <p1>AI-FullStack
                Developer</p1>
                <p2>A Front-End Developer is responsible for developing new user-facing features, determining the structure and design of web pages, building reusable codes, optimizing page loading times, and using a variety of markup languages to create the web pages.</p2>
              </div>
            </div>
            <div className='course-path-1'>
              <img src={coursepath3} alt="" className='course-path-1-img'/>
              <div className='course-path-1-data'>
                <p1>Frontend 
                UI Developer</p1>
                <p2>A Front-End Developer is responsible for developing new user-facing features, determining the structure and design of web pages, building reusable codes, optimizing page loading times, and using a variety of markup languages to create the web pages.</p2>
              </div>
            </div>
            <div className='course-path-1'>
              <img src={coursepath4} alt="" className='course-path-1-img'/>
              <div className='course-path-1-data'>
                <p1>Team Lead</p1>
                <p2>A Front-End Developer is responsible for developing new user-facing features, determining the structure and design of web pages, building reusable codes, optimizing page loading times, and using a variety of markup languages to create the web pages.</p2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hirrecompanyfull">
          
          <div className="hire-company-container">
            <div className='hire-company-part-a'>
              <div className='hire-company-sub-part'>
          <FaUsersLine className='hire-course-icon'/>
          <p1 className='hire-course-icon-tag'>750 HIRING PARTNERS</p1>
          </div>
            <div className="hire-company-logos">
              {companyLogos.map((logo, index) => (
                <img
                  key={index}
                  src={logo}
                  alt={`Logo ${index + 1}`}
                  className="hire-logo-course"
                />
              ))}
            </div>
            </div>
            <div className="trusted-section">
              <img className="trusted-img" src={trusted} alt="Trusted" />
            </div>
          </div>
      </div>

      <div className='cp-mentors'>
        <div className='cp-mentor-title'>
          <p1>INI</p1>
          <p2>working at companies bigger brands and are extremely important to us and we are grateful for the opportunity to have placed them on such impressive teams around the country.</p2>
        </div>
        <div className='cp-mentor-components'>
        <div className="carousel-container">
      <div className="cp-mentor-components carousel-track">
        {/* Duplicating list for infinite scrolling effect */}
        {[...mentors, ...mentors].map((mentor, index) => (
          <div className="cp-mentor-1" key={index}>
            <img src={mentor.image} alt={mentor.name} className="cp-mentor-image" />
            <div className="cp-mentor-1-data">
              <p1>{mentor.name}</p1>
              <p2>{mentor.role}</p2>
              <div className="cp-mentor-company-image-div">
                <img src={mentor.company} alt="Company" className="cp-mentor-company-image" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
        </div>
      </div>

      <div className="cr-certification-container">
<h2>Industry Recognized Certification Course</h2>


<div className="cr-certification-content">
  <div className="cr-certification-text">
  <div className="cr-certification-tabs">
  {Object.keys(certifications).map((tab) => (
    <span
      key={tab}
      className={activeTab === tab ? 'active' : ''}
      onClick={() => setActiveTab(tab)}
    >
      {tab}
    </span>
  ))}
</div>
    <h3>{certifications[activeTab].title}</h3>
    <ul>
      {certifications[activeTab].points.map((point, index) => (
        <li key={index}>&#10004; {point}</li>
      ))}
    </ul>
  </div>
  <div className="cr-certification-image">
    <img src={certifications[activeTab].img} alt={activeTab} />
  </div>
</div>
</div>

      <div className="bootcamp-container">
        <header className="bootcamp-header">
          <h3 className="bootcamp-subheading">
          Tools We Use and Learn
          </h3>
        </header>

        <section className="bootcamp-offerings">
          <Cards
            image={boexcel}
            title="Advance Excel"
            description="The Advanced Excel course equips learners with expert-level skills in data analysis, automation using formulas, pivot tables, and macros. It is ideal for professionals aiming to enhance productivity and make data-driven decisions efficiently."
          />
          <Cards
            image={bosql}
            title="My SQL"
            description="The MySQL course provides in-depth knowledge of database design, querying, and management using SQL commands. It is perfect for aspiring developers and data analysts to efficiently handle and manipulate relational databases."
          />
          <Cards
            image={bopowerbi}
            title="Power BI"
            description="The Power BI course teaches users to transform raw data into interactive dashboards and insightful visual reports. It is perfect for professionals seeking to master data visualization and business intelligence tools."
          />
          <Cards
            image={botableau}
            title="Tableau"
            description="The Tableau course teaches data visualization and dashboard creation using real-world datasets to derive actionable insights. It’s perfect for professionals seeking to master business intelligence and visual storytelling."
          />
          <Cards
            image={bonumpypanda}
            title="Numpy & Pandas"
            description="The NumPy and Pandas course provides a strong foundation in numerical computing and data manipulation using Python. It is designed to help learners analyze, clean, and process large datasets efficiently for data science and machine learning tasks."
          />
          <Cards
            image={bobusinessstatistics}
            title="Business Statistics"
            description="The Business Statistics course provides foundational knowledge in statistical methods for analyzing business data and making informed decisions. It covers topics like probability, regression, hypothesis testing, and data interpretation."
          />
          <Cards
            image={bopython}
            title="Python"
            description="The Python course provides a comprehensive foundation in programming, covering syntax, data structures, functions, and object-oriented concepts. It is perfect for beginners and professionals looking to automate tasks, analyze data, or develop applications."
          />
          <Cards
            image={boaws}
            title="AWS"
            description="The AWS course provides comprehensive training on cloud computing services, including EC2, S3, Lambda, and more. It prepares learners to design, deploy, and manage scalable and secure applications on the AWS platform."
          />
          <Cards
            image={bobigdata}
            title="Big Data Analytics"
            description="The Big Data Analytics course provides in-depth knowledge of processing and analyzing large datasets using tools like Hadoop, Spark, and SQL. It prepares learners to extract actionable insights and make data-driven decisions in real-world scenarios."
          />
        </section>
      </div>

      <div className='cp-pricing-container'>
        <p className='cp-pricing-title'>Simple, Transparent Pricing</p>
        <div className='cp-pricing-box'>
          <div className='cp-price-left'>
            <h3>What's Included in the Price</h3>
            <p>Features/Benefits</p>
            <ul>
              <li>Get Advanced Certificate Programme from Vertocity without quitting your job.</li>
              <li>Practical Learning with Industry Projects and Case Studies</li>
              <li>Rigorous Cutting Edge Curriculum developed in Collaboration with Teaching experts and Industry leaders in DevOps</li>
              <li>Dedicated Student support team from Vertocity</li>
              <li>Networking opportunities with our+ alumni & leading industry experts</li>
            </ul>
          </div>
          <div className='cp-price-right'>
            <h2>Empowering learners of tomorrow</h2>
            <p>Over 2,300 students have completed this course and started working at their dream job, whats stopping you?</p>
          </div>
        </div>
      </div>

     <div className='cp-booking-container'>
      <div className='cp-booking-session'>
        <h1>Book live demo class now!</h1>
        <h3>Register now for our FREE live demo class on full-stack web development.</h3>
        <button className='cp-booking-button'>Register Now</button>
      </div>
      </div>

      <div className="faq-container">
        <h3 className="faq-title">FAQ</h3>
        <h1 className="faq-heading">Frequently Asked Questions</h1>
        <div className="faq-content">
          {/* Left Tabs */}
          <div className="faq-tabs">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`Course14-tab ${activeTabs === index ? "active" : ""}`}
                onClick={() => toggleTab(index)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Right FAQ Section */}
          <div className="faq-details">
            <h2 className="faq-question">{faqs[activeTabs].question}</h2>
            {faqs[activeTabs].answer && (
              <p className="faq-answer">{faqs[activeTabs].answer}</p>
            )}
            <ul className="faq-list">
              {faqs.map((faq, index) =>
                activeTabs !== index ? (
                  <li key={index} className="faq-list-item">
                    {faq.question} <span className="faq-toggle">+</span>
                  </li>
                ) : (
                  <li key={index} className="faq-list-item active">
                    {faq.question} <span className="faq-toggle">×</span>
                  </li>
                )
              )}
            </ul>
            <button className="view-more-btn">View More</button>
          </div>
        </div>
      </div>
    </div>  
    </div>
  );
};

export default CoursePage
